import { observable, action, computed } from 'mobx';
import agent from '../services/web/agent';
import userSharedFormsValidator from '../services/validations/userSharedFormsValidator';
import passwordMatchValidator from '../services/validations/passwordMatchValidator';


class FirstAdminRegisterationStore {

    @observable inProgress;
    @observable isFirstAdminExistence;
    @observable userNameValidationMessage;
    @observable firstNameValidationMessage;
    @observable lastNameValidationMessage;
    @observable emailValidationMessage;
    @observable passwordValidationMessage;
    @observable passwordValidationMessage2;
    @observable passwordConfirmedValidationMessage;
    @observable registerErrorMessage;
    @observable isRegisterError = null;

    @observable values = {
        userName: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmedPassword: ''
    };

    formErrors = [];

    @action firstAdminExistence() {

        const _this = this;

        return agent.Users.firstAdminExistence()
            .then(action(function (isFirstAdminExistence) {
                
                return _this.isFirstAdminExistence = isFirstAdminExistence;
            }));
    }

    @action resetFirstAdminValues() {
        this.values.userName = '';
        this.values.firstName = '';
        this.values.lastName = '';
        this.values.email = '';
        this.values.password = '';
        this.values.confirmedPassword = '';
    }

    validateFirstName() {

        const validation = userSharedFormsValidator.validateFirstName(this.values.firstName);

        this.firstNameValidationMessage = validation.errors.first('firstName');

        this.formErrors.push(validation.errorCount);
    }

    validateLastName() {

        const validation = userSharedFormsValidator.validateLastName(this.values.lastName);

        this.lastNameValidationMessage = validation.errors.first('lastName');

        this.formErrors.push(validation.errorCount);
    }

    validateUserName() {

        const validation = userSharedFormsValidator.validateUserName(this.values.userName);

        this.userNameValidationMessage = validation.errors.first('userName');

        this.formErrors.push(validation.errorCount);
    }

    validateEmail() {

        const validation = userSharedFormsValidator.validateEmail(this.values.email);

        this.emailValidationMessage = validation.errors.first('email');

        this.formErrors.push(validation.errorCount);
    }

    validatePassword() {

        const result = passwordMatchValidator.validatePassword(this.values.password);
  
        this.passwordValidationMessage = result.passwordValidationMessage;
  
        this.formErrors.push(result.validation.errorCount);
    }
  
    validateMatchPassword() {
		const result = passwordMatchValidator.validatePassword(this.values.confirmedPassword);
		this.passwordValidationMessage2=result.passwordValidationMessage;

        const resultMatch = passwordMatchValidator.validateMatchPassword(this.values.password, this.values.confirmedPassword);
        this.passwordConfirmedValidationMessage = resultMatch.passwordValidationMessage;
  
        this.formErrors.push(result.validation.errorCount);
        this.formErrors.push(resultMatch.validation.errorCount);
    }

    @action validateForm() { 

        this.formErrors = [];
        this.validateFirstName();
        this.validateLastName();
        this.validateUserName();
        this.validateEmail();
        this.validatePassword();
        this.validateMatchPassword();
        
        if (this.formErrors.filter((valid) => valid > 0).length > 0) {
            return false;   
        }

        return true;
    }

    @action createFirstAdmin() {
                
        this.inProgress = true;
        const _this = this;
        this.registerErrorMessage = '';
        this.isLoginError = false;

        return agent.Users.createFirstAdmin({
            userName: this.values.userName,
            firstName: this.values.firstName,
            lastName: this.values.lastName,
            email: this.values.email,
            password: this.values.password
        }).then(function () {

            _this.resetFirstAdminValues();

        }).catch(action((err) => {

            _this.inProgress = false;
            
            if (err && err.response && err.response.text) {
    
                this.isRegisterError = true;
                this.registerErrorMessage = JSON.parse(err.response.text).Message;
            }

            this.errors = err.response && err.response.body && err.response.body.errors;
            throw err;
        }));
    }

    @action setFirstName(firstName) {
        this.values.firstName = firstName;
    }

    @action setLastName(lastName) {
        this.values.lastName = lastName;
    }

    @action setUserName(userName) {
        this.values.userName = userName.trim();
    }

    @action setEmail(email) {
        this.values.email = email.trim();
    }

    @action setPassword(password) {
        this.values.password = password;
    }

    @action setConfirmedPassword(password) {
        this.values.confirmedPassword = password;
    }
}

export default new FirstAdminRegisterationStore();


// WEBPACK FOOTER //
// ./src/stores/firstAdminRegisterationStore.js